import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useHistory } from 'react-router-dom'
import { useAuth } from 'context/AuthContext'
import { Plus, Dashboard, Settings, Cog, Logout } from 'components/misc/Icons'
import { AppState } from 'App';

import Avatar from 'components/misc/Avatar'

const AccountButton = () => {

    const {t, i18n} = useTranslation('common');
    const [appState, setAppState] = useContext(AppState)

    const node = useRef();
    const [isOpen, setIsOpen] = useState(false)
    const { logout } = useAuth()

    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpen(false);
    };

    async function handleLogout() {
        try {
            await logout()
            useHistory.push("/login")
        }
        catch {
            console.log("Failed to log out")
        }
        finally {
            console.log('logout completed')
        }
    }

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div
            ref={node}
            onClick={e => setIsOpen(!isOpen)}
            className="cursor-pointer focus:outline-none">
            <Avatar width={10} height={10}
        />

            {isOpen && (

                <div className="absolute w-56 py-2 mt-2 overflow-hidden border rounded shadow-md z-1100 -ml-44 bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
                    <div className="flex flex-row items-center justify-start px-2 mt-2 mb-2">
                        <div>
                            <Avatar width={10} height={10}/>
                        </div>
                        <div className="ml-3 text-left">
                            <span className="block text-sm font-semibold text-textlight dark:text-textdark">{appState.username}</span>

                        </div>
                    </div>

                    <Link to="/dashboard">
                        <button className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform cursor-not-allowed hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                            <Dashboard width="6" height="6" stroke="1"/>
                            <span className="inline-block ml-2 text-sm">{t('AB_dashboard')}</span>
                        </button>
                    </Link>
                    <Link to="/settings">
                        <button className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform cursor-not-allowed hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                            <Settings width="6" height="6" stroke="1"/>
                            <span className="inline-block ml-2 text-sm">{t('AB_appSettings')}</span>
                        </button>
                    </Link>
                    <button className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform cursor-not-allowed hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark">
                        <Cog width="6" height="6" stroke="1"/>
                        <span className="inline-block ml-2 text-sm">{t('AB_accountSettings')}</span>
                    </button>
                    <button className="flex items-center w-full px-2 py-3 transition-colors duration-200 transform hover:bg-blue-500 hover:text-white dark:hover:bg-borderdark text-textlight dark:text-textdark" onClick={handleLogout}>
                        <Logout width="6" height="6" stroke="1"/>
                        <span className="inline-block ml-2 text-sm">{t('AB_logout')}</span>
                    </button>
                </div>

            )}
        </div>
    )
}

export default AccountButton
